import { gql } from '@apollo/client';

export const SUGGESTIONS_FRAGMENT = gql`
  fragment Suggestion on Suggestions {
    contentType
    entities
  }
`;
